import React from 'react';
import { useOpenWorkspacePanel } from '../../panels/use-open-workspace-panel';

const QUEUE_CREATION_PANEL_WIDTH = 1076;
const QUEUE_CREATION_PANEL_HEIGHT = 525;

export function useCreateQueueCreationPanel(): () => void {
    const openWorkspacePanel = useOpenWorkspacePanel();

    const openQueueCreationPanel = React.useCallback(() => {
        openWorkspacePanel({
            workspacePanelConfig: {
                width: QUEUE_CREATION_PANEL_WIDTH,
                height: QUEUE_CREATION_PANEL_HEIGHT,
                workspacePanelType: 'QUEUE_FORM',
            },
        });
    }, [openWorkspacePanel]);

    return openQueueCreationPanel;
}
